import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentInactivityTime = styled.div`
  width: 30%;
  height: auto;
  background: white;
  margin: 2em auto;
  border-radius: 3px;
  text-align: center;
  padding: 1em;
  display: grid;
  grid-template-rows: 2em 6em;
  label {
    font-size: 1.05vw;
    margin: 1.5rem 0 3em 0;
  }
  svg {
    margin: auto;
    font-size: 2.3em;
  }
`;
export const ButtonOk = styled.button`
  color: white;
  height: 29px;
  padding: 3px 10px;
  font-size: 12px;
  background: ${({ theme }) => theme.primary.purple};
  border: none;
  width: 7em;
  border-radius: 4px;
  @media only screen and (max-width: 400px) {
    font-size: 8px;
    width: 5em;
    height: 16px;
  }
`;
